export default "__VITE_ASSET__DSfuTx$o__"